import { Tooltip, useTheme } from "@mui/material";
import LockIcon from "assets/icon/LockIcon";
import useAuth from "hooks/useAuth";
import useLocales from "hooks/useLocales";

interface IPermissionInfoProps {
  disableDimensions?: boolean;
  permissionMessage?: string;
}

const PermissionInfo = (props) => {
  const {
    disableDimensions = false,
    permissionMessage = "you_dont_have_permission_to_access_this_page",
  } = props;
  const theme = useTheme();
  const { translate } = useLocales();
  const { isSupplierDocumentExpired } = useAuth();

  return (
    <Tooltip
      title={
        isSupplierDocumentExpired
          ? `${translate("suppler_document_expired")}. ${translate("update_support_document_in_profile_page")}`
          : translate(permissionMessage)
      }
    >
      <span>
        <LockIcon
          height={15}
          width={15}
          customColor={theme.palette.primary.dark}
          disableDimentions={disableDimensions}
        />
      </span>
    </Tooltip>
  );
};
export default PermissionInfo;
